import request from '../request'
import apis from '../apis'

export default {
    // 分页查询用户权限信息，用于用户权限批处理USER_PERMISSION
    getUserPermission({ params, pageVO }) {
        return request.get(`${apis.GET_USER_PERM}/${pageVO.pageSize}/${pageVO.curPage}`, { params });
    },
    delUserPermission(params) {
        return request.put(apis.GET_DEL_PERM, params)
    },
    postponeUserPermission(params) {
        return request.put(apis.GET_POSTPONE_PERM, params)
    },
    addUserPermission(params) {
        return request.post(apis.GET_ADD_PERM, params)
    },
    // 用户权限获得延期最大时间
    getSinglePerm() {
        return request.get(apis.GET_SINGLE_PERM)
    }
}
